import { DeepPartial } from '@src/slide/infrastructure/module/independent/ts-tools/deep-partial';
import { ITransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { ICTSlideTransition } from '@tencent/slide-sdk-pb-model';
import { invertMapping, speedSdkMapping } from '@src/slide/domain/ui-model/element-modeles/transition/type-mapping';
import { DeepReadonly } from 'ts-essentials';

export default abstract class BaseTransitionConverter {
    public convertPartialSdkToUi(
        sdkData: DeepReadonly<ICTSlideTransition>,
        uiData: ITransition,
    )  {
        if (sdkData.spd) {
            uiData.speed = speedSdkMapping[sdkData.spd];
        }

        if (sdkData.dur) {
            uiData.duration = parseInt(sdkData.dur);
        }
    }

    public convertPartialUiToSdk(
        uiData: DeepPartial<ITransition>,
        sdkData: ICTSlideTransition,
    ) {
        if (uiData.speed) {
            sdkData.spd = invertMapping(speedSdkMapping)[uiData.speed];
        }

        if (uiData.duration) {
            sdkData.dur = uiData.duration.toString();
        }
    }
}

export class DefaultTransitionConverter extends BaseTransitionConverter {}
